import { Link } from "react-router-dom";

import { logo1881 } from "../../assets/img";
import UserNav from "./UserNav";

const MainNav = () => {
  return (
    <nav className="navbar fixed-top navbar-dark bg-primary">
      <div className="container-fluid">
        <span className="navbar-brand mb-0 h1">
          <a href="https://www.1881.no">
            <img src="opplysningen-1881-logo-screen-primary-rgb.svg" alt="Opplysningen 1881" width="27" height="28" className="cc-logo-o-1881 d-md-none"></img>
            <img src={logo1881} alt="Opplysningen 1881" width="115" height="28" className="cc-logo-o-1881 d-none d-md-inline-block" />
          </a>
          <Link to="/">
            <span>Min bedrift</span>
          </Link>
        </span>
        <UserNav />
      </div>
    </nav>
  );
};

export default MainNav;
